var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___NGR3LX",
  "hU": "SudoVerificationModal.module__unavailable___NGR3LX",
  "TJ": "SudoVerificationModal.module__unavailableTitle___NGR3LX",
  "$r": "SudoVerificationModal.module__unavailableBody___NGR3LX",
  "zc": "SudoVerificationModal.module__formError___NGR3LX",
  "kK": "SudoVerificationModal.module__passkeyHint___NGR3LX",
};

module.exports = exports;
